module.exports = __webpack_public_path__ + "img/ossetia.4017ffaa.svg";